import { render, staticRenderFns } from "./DrawerGroup.vue?vue&type=template&id=066f2cc2"
import script from "./DrawerGroup.vue?vue&type=script&lang=ts"
export * from "./DrawerGroup.vue?vue&type=script&lang=ts"
import style0 from "./DrawerGroup.vue?vue&type=style&index=0&id=066f2cc2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports